export default {
  name: "verify-email",

  data() {
    return {
      form: {
        email: ""
      },
      rules: {
        email: [{
          type: "email",
          required: true,
          message: this.$t("Invalid email address format"),
          trigger: "blur"
        }]
      }
    };
  },

  methods: {
    submitForm(form) {
      this.$refs[form].validate(async valid => {
        if (valid) {
          this.$emit("submit", this.form);
        }
      });
    }

  }
};